const SPREADSHEET_EXT = /\.(xlsx|xlsm|xlsb|xls)$/i;
const WORD_EXT = /\.(docx|doc)$/i;
const PRESENTATION_EXT = /\.(pptx|ppt)$/i;

/** @typedef {'spreadsheet' | 'word' | 'presentation'} OfficeDocumentKind */

/**
 * @returns {OfficeDocumentKind | null}
 */
export function getOfficeDocumentKind(mime, name) {
  const m = (mime || '').toLowerCase();
  const n = name || '';

  if (
    m.includes('spreadsheet') ||
    m.includes('excel') ||
    m.includes('sheet') ||
    SPREADSHEET_EXT.test(n)
  ) {
    return 'spreadsheet';
  }
  if (m.includes('wordprocessing') || m.includes('msword') || WORD_EXT.test(n)) {
    return 'word';
  }
  if (m.includes('presentation') || m.includes('powerpoint') || PRESENTATION_EXT.test(n)) {
    return 'presentation';
  }
  return null;
}

export function isPreviewableOfficeDocument(mime, name) {
  return getOfficeDocumentKind(mime, name) != null;
}

export function officeDocumentKindLabel(kind) {
  if (kind === 'spreadsheet') return 'Spreadsheet';
  if (kind === 'word') return 'Document';
  if (kind === 'presentation') return 'Presentation';
  return 'Office file';
}

export function officeDocumentPreviewLabel(kind) {
  if (kind === 'spreadsheet') return 'Open spreadsheet';
  if (kind === 'word') return 'Open document';
  if (kind === 'presentation') return 'Open presentation';
  return 'Open file';
}
